import Vue from 'vue'

export const state = () => ({
  participants: {
    category1: {
      items: [],
      nextPageId: 1,
      buttonDisabled: false
    },
    category2: {
      items: [],
      nextPageId: 1,
      buttonDisabled: false
    },
    category3: {
      items: [],
      nextPageId: 1,
      buttonDisabled: false
    }
  },
  currentCategoryId: null,
  currentScrollToElId: null,
  activeCategory: '',
  sortedArr: []
})

export const actions = {
  // updateParticipant({ state, commit }, { categoryId, item }) {
  //   const requestedItem = state.participants[categoryId].items.find(
  //     el => el.id === item.id
  //   )
  //   console.log(requestedItem)
  //   // commit('SET_PARTICIPANT')
  // }
}

export const mutations = {
  SET_ID(state, id) {
    Vue.set(state, 'currentCategoryId', id)
  },
  SET_ITEM_ID(state, id) {
    Vue.set(state, 'currentScrollToElId', id)
  },
  UPDATE_PARTICIPANT(state, { categoryId, itemId, likes, liked }) {
    state.participants[categoryId].items.forEach(el => {
      if (el.id === itemId) {
        el.likes = likes
        el.liked = liked
      }
    })
  },
  SET_PARTICIPANTS(state, { id, items }) {
    if (id) state.participants[id].items = items
  },
  INCREMENT_PAGE_ID(state, { id }) {
    state.participants[id].nextPageId += 1
  },
  SET_ACTIVE_CATEGORY(state, id) {
    Vue.set(state, 'activeCategory', id)
  },
  SET_DISABLED_BUTTON(state, { id, condition }) {
    state.participants[id].nextPageExist = condition
  },
  SET_SORTED_ARR(state, arr) {
    state.sortedArr = arr
  }
}

export const getters = {
  getParticipantsById: state => id => state.participants[id],
  participantsArr: state => state.participants,
  catId: state => state.currentCategoryId,
  getSortedArr: state => state.sortedArr,
  activeCategory: state => state.activeCategory,
  currentScrollToElId: state => state.currentScrollToElId,
  getNextPageId: state => id => state.participants[id].nextPageId,
  getDisabledButtonState: state => id => {
    state.participants[id] ? state.participants[id].nextPageExist : false
  }
}



// WEBPACK FOOTER //
// ./store/participants.js